module.exports = "<div layout=\"row\" layout-align=\"center center\" flex-100>\n  <div layout=\"column\">\n    <p>\n      This Page Contains the mapping of each end point and the available Request\n      Methods\n    </p>\n    <md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.download()\">\n      Download CSV File\n    </md-button>\n  </div>\n</div>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\"></main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/authorization/authorization.html
// module id = 2051
// module chunks = 0